var Backbone = require('backbone'),
    fvChannel = require('glRadio').channel('FV');


module.exports = Backbone.Model.extend({

    defaults: {
        allow_flash_notes: 'N',
        allow_consults: 'N',
        floating_reason_codes: 'N',
        page_note_title_max_length: null // length of the field dependant on the schema version ( DVBC-1808 )
    },

    url: function() {
        return fvChannel.request('apiUrl').systemPolicies;
    },

    allowFlashNotes: function() {
        return this.get('allow_flash_notes') === 'Y';
    },
    allowConsults: function() {
        return this.get('allow_consults') === 'Y';
    },
    applyFloatingReasonCodes: function() {
        return this.get('floating_reason_codes') === 'Y';
    },
    getPageNoteTitleMaxLength: function() {
        return this.get('page_note_title_max_length');
    }


});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/FV/systemPolicies.js
 ** module id = 767
 ** module chunks = 0
 **/